import React from "react";
import AddExportDialog from "./AddExportDialog.js";
import { withStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

export default function UploadExport(props) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div>
      <Button
        style={{
          color: "#FFFFFF",
          backgroundColor: "#91C73C",
          fontWeight: "normal",
          marginLeft: "15px",
          fontWeight: "bold",
          height: "40px",
          fontSize: "0.75rem",
          padding: "5px 15px",
          fontFamily: '"Source Sans Pro",sans-serif',
        }}
        onClick={handleClickOpen}
      >
        <PersonAddIcon fontSize="small" style={{
          marginRight: "6px"
        }}/>
        Nouvel export
      </Button>

      <Dialog
        onClose={handleClose}
        aria-labelledby="adduser-dialog-title"
        fullWidth={true}
        maxWidth="lg"
        open={open}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleClose}>
          Ajout d'un export
        </CustomDialogTitle>
        <DialogContent dividers>
            <AddExportDialog closeModal={handleClose} {...props}/>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </div>
  );
}
